"use strict";
var thumbs = document.querySelector("#thumbs");
var largeImg = document.querySelector("#largeImg");
thumbs.addEventListener("click", function(ev) {
    var link = event.target.closest("a");
    if (!link) return;
    event.preventDefault();
    largeImg.src = link.href;
});

//# sourceMappingURL=index.1c5eef5f.js.map
